<template>
  <v-app-bar
    app
    absolute
    elevation="0"
    :class="{
      'sidebar-minimized': miniSidebar,
      'header-atendimento': ['atendimentoForm', 'atendimentoFormUpdate'].includes($route.name),
    }"
  >
    <template>
      <v-btn
        v-if="ehMobile"
        icon
        large
        @click="handleBurgerClick"
        class="btn-burger-mobile mr-2"
      >
        <v-icon color="var(--especialidade-primary)" size="35">mdi-menu</v-icon>
      </v-btn>
      <v-row class="align-center">
        <v-col class="d-flex align-center" cols="auto">
          <v-toolbar-title class="titulo d-flex align-center" :class="{ 'titulo-com-burger': ehMobile }">
            {{ titulo }}
            <v-tooltip bottom v-if="tituloIcon && mostrarTooltipPacientes">
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-2 cursor-pointer" color="#2e4b9d" v-bind="attrs" v-on="on">
                  {{ tituloIcon }}
                </v-icon>
              </template>
              <span>
                Quantidade total de pacientes ativos: <b>{{ totalPacientesAtivos }}</b><br>
                Quantidade total de pacientes inativos: <b>{{ totalPacientesInativos }}</b>
              </span>
            </v-tooltip>
            <v-icon v-else-if="tituloIcon" class="ml-2" :color="'#2e4b9d'">{{ tituloIcon }}</v-icon>

            <template v-if="['atendimentoForm', 'atendimentoFormUpdate'].includes($route.name)">
              <span class="separador-vertical especialidade-separador">|</span>
              <span class="paciente-nome">{{ exibirNomePaciente() }}</span>
              <div class="header-atendimento-actions">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="$emit('mostrarInformacoes')"
                      class="ml-3 info-btn-pulse" :color="corEspecialidade">
                      <v-icon class="mx-auto">mdi-information</v-icon>
                    </v-btn>
                  </template>
                  <span>Exibir informações do paciente</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-15 rounded-pill" color="error" v-bind="attrs" v-on="on" @click="$emit('cancelar')">
                      Cancelar
                    </v-btn>
                  </template>
                  <span>Cancelar atendimento</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-9 rounded-pill" color="success" v-bind="attrs" v-on="on" @click="$emit('salvar')"
                      :disabled="desabilitaBotaoSalvarAtendimento">
                      {{ clickSalvar ? 'Salvando...' : 'Salvar' }}
                    </v-btn>
                  </template>
                  <span>Salva temporariamente o atendimento, permitindo edições futuras</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-9 rounded-pill" color="primary" v-bind="attrs" v-on="on" @click="$emit('finalizar')"
                      :disabled="desabilitaBotaoFinalizarAtendimento">
                      {{ clickFinalizar ? 'Finalizando...' : 'Finalizar' }}
                    </v-btn>
                  </template>
                  <span>Conclui definitivamente o atendimento, bloqueando edições futuras</span>
                </v-tooltip>
                <v-tooltip v-if="somenteTipoConsultaPreenchidoNaConsulta" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" class="ml-2 info-btn-lampada">
                      <v-icon class="mx-auto"> mdi-help-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Para habilitar o botão de salvar e finalizar o atendimento, ao escolher um Tipo de Consulta, é
                    necessário
                    preencher pelo menos um dos campos na aba de Consulta.</span>
                </v-tooltip>
                <v-chip outlined color="red darken-1 ml-5" class="text-uppercase font-weight-bold px-4" label>
                  <v-icon left small>mdi-timer-outline</v-icon>
                  TEMPO DECORRIDO: {{ tempo }}
                </v-chip>
              </div>
            </template>
          </v-toolbar-title>
        </v-col>
        <v-col v-if="$route.name === 'atendimentos' && temAtendimentosNaoFinalizados" class="d-flex justify-center mt-4"
          cols="12" md="8" sm="12" xs="12">
          <v-btn class="btn-alerta" outlined @click="abrirModalAtendimentosNaoFinalizados">
            Atenção, há atendimentos não finalizados, clique para saber mais
          </v-btn>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
    </template>
    <UserMenu />
    <ModalAtendimentosNaoFinalizados ref="modalAtendimentosNaoFinalizados"></ModalAtendimentosNaoFinalizados>
  </v-app-bar>
</template>

<script lang="ts">
import Vue from 'vue';
import NavigationHelper from '../helpers/NavigationHelper';
import {
  getModoNoturno,
  removeToken,
  setModoNoturno,
  decode,
  getToken,
} from '../utils/Token';
import { AlertaPerguntaSimOuNaoBooleano, AlertaSimplesErro } from '../helpers/MensagemHelper';
import { UsuarioService } from '../services/UsuarioService';
import ModalAtendimentosNaoFinalizados from '../views/atendimento/ModalAtendimentosNaoFinalizados.vue';
import UserMenu from './UserMenu.vue';
import { CoresHelper } from '../utils/coresHelper';
import { LoginService } from '../services/LoginService';

export default Vue.extend({
  name: 'soi-header',
  components: {
    ModalAtendimentosNaoFinalizados,
    UserMenu,
  },
  props: {
    value: {
      type: Boolean,
    },
    titulo: {
      type: String,
      required: true,
    },
    tituloIcon: {
      type: String,
      required: false,
      default: '',
    },
    nomePaciente: {
      type: String,
      required: false,
      default: '',
    },
    nomeSocial: {
      type: String,
      required: false,
      default: '',
    },
    usarNomeSocialComoPrincipal: {
      type: Boolean,
      required: false,
      default: false,
    },
    clickSalvar: {
      type: Boolean,
      default: false,
    },
    clickFinalizar: {
      type: Boolean,
      default: false,
    },
    dadosAbaConsultaEstaVazio: {
      type: Boolean,
      required: false,
      default: false,
    },
    dadosConvenioEstaVazio: {
      type: Boolean,
      required: false,
      default: false,
    },
    somenteTipoConsultaPreenchidoNaConsulta: {
      type: Boolean,
      required: false,
      default: false,
    },
    atendimentoSemDados: {
      type: Boolean,
      required: false,
      default: false,
    },
    mostrarTooltipPacientes: {
      type: Boolean,
      default: false,
    },
    totalPacientesAtivos: {
      type: Number,
      default: 0,
    },
    totalPacientesInativos: {
      type: Number,
      default: 0,
    },
    miniSidebar: {
      type: Boolean,
      default: false,
    },
    abrirMenuMobile: {
      type: Function,
      default: () => { },
    },
    ehMobile: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    user() {
      this.modoNoturno = getModoNoturno();
    },
    '$route.name': {
      handler(name) {
        this.visualizar = !!(name !== 'login'
          && name !== 'recuperarSenha'
          && name !== 'confirmaEmail'
          && name !== 'confirmaAgendamento');
      },
    },
  },
  data() {
    return {
      menuOpen: false,
      inicioMs: 0,
      agoraMs: 0,
      id: null,
      user: {
        nomeCompleto: '',
        role: '',
      },
      modoNoturno: getModoNoturno(),
      temAtendimentosNaoFinalizados: false,
    };
  },
  computed: {
    desabilitaBotaoFinalizarAtendimento(): boolean {
      return this.clickFinalizar || this.dadosConvenioEstaVazio || this.atendimentoSemDados;
    },
    desabilitaBotaoSalvarAtendimento(): boolean {
      return this.clickSalvar || this.dadosConvenioEstaVazio || this.atendimentoSemDados;
    },
    tempo() {
      const s = Math.floor((this.agoraMs - this.inicioMs) / 1000);
      const hh = String(Math.floor(s / 3600)).padStart(2, '0');
      const mm = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      const ss = String(s % 60).padStart(2, '0');
      return `${hh}:${mm}:${ss}`;
    },
    corEspecialidade() {
      const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--especialidade-primary').trim();
      return primaryColor || '#2e4b9d';
    },
  },
  mounted() {
    this.atualizarInformacoesUsuario();
    this.$root.$on('atualizar-usuario', this.atualizarInformacoesUsuario);
    this.$vuetify.theme.dark = this.modoNoturno;
    this.verificarAtendimentosNaoFinalizados();
    this.inicioMs = Date.now();
    this.agoraMs = Date.now();
    this.id = setInterval(() => { this.agoraMs = Date.now(); }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.id);
  },
  methods: {
    handleBurgerClick() {
      if (this.abrirMenuMobile && typeof this.abrirMenuMobile === 'function') {
        this.abrirMenuMobile();
      }
    },
    exibirNomePaciente() {
      if (this.usarNomeSocialComoPrincipal && this.nomeSocial && this.nomeSocial.trim() !== '') {
        return this.nomeSocial;
      }
      return this.nomePaciente;
    },
    atualizarInformacoesUsuario() {
      const token = getToken();
      if (token) {
        this.user = decode(token);
      }
    },
    alterarTemaDoSistema() {
      const usuarioService = new UsuarioService();
      usuarioService.MudarTema().then(
        (res) => {
          this.modoNoturno = res.data;
          this.$vuetify.theme.dark = this.modoNoturno;
          setModoNoturno(this.modoNoturno);
        },
        (err) => {
          // eslint-disable-next-line no-alert
          alert('Não foi possível realizar a operação');
        },
      );
    },
    async sair() {
      if (await AlertaPerguntaSimOuNaoBooleano('Deseja sair do sistema?')) {
        try {
          const loginService = new LoginService();
          await loginService.logout();
        } catch (error) {
          console.error('Erro ao realizar logout:', error);
        }

        removeToken();
        this.$vuetify.theme.dark = false;
        CoresHelper.limparEspecialidade();
        NavigationHelper.navigate('login');
      }
    },
    redirecionarParaClinica() {
      if (this.user.role === 'Admin' || this.user.role === 'Host' || this.user.role === 'Admin_Medico') {
        NavigationHelper.navigate('clinicasFormUpdate');
      }
    },
    redirecionarParaUsuario() {
      NavigationHelper.navigate('perfilDoUsuario');
    },
    formatarIniciaisNomeCompleto(nomeCompleto: string) {
      if (!nomeCompleto) return 'H';
      const partes = nomeCompleto.trim().split(' ');
      if (partes.length === 1) return partes[0].charAt(0).toUpperCase();
      return partes[0].charAt(0).toUpperCase() + partes[partes.length - 1].charAt(0).toUpperCase();
    },
    async verificarAtendimentosNaoFinalizados() {
      try {
        const response = await this.$refs.modalAtendimentosNaoFinalizados.atendimentoService.GetAllAtendimentosNaoFinalizadosTodos();
        this.temAtendimentosNaoFinalizados = response.data && response.data.length > 0;
        if (!this.temAtendimentosNaoFinalizados && this.$refs.modalAtendimentosNaoFinalizados) {
          this.$refs.modalAtendimentosNaoFinalizados.modalAberto = false;
        }
      } catch (error) {
        AlertaSimplesErro('Erro ao verificar atendimentos não finalizados:', error);
        this.temAtendimentosNaoFinalizados = false;
      }
    },
    async abrirModalAtendimentosNaoFinalizados() {
      await this.$refs.modalAtendimentosNaoFinalizados.abrirModalAtendimentosNaoFinalizadosTodos();
      await this.verificarAtendimentosNaoFinalizados();
    },
  },
});
</script>

<style>
.titulo {
  margin-left: 3.625rem;
  margin-top: 1rem;
  color: #2e4b9d;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 2rem;
  text-align: justify;
  white-space: nowrap;
}

.titulo-com-burger {
  margin-left: 0.5rem !important;
}

.btn-burger-mobile {
 margin-top: 1.1rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

@keyframes pulse {
  10% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.4);
  }

  30% {
    box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
  }

  50% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
}

.menu-user {
  margin-left: 1.875rem;
  margin-top: 1rem;
  display: flex;
  align-items: center;
  padding: 0.75rem;
  cursor: pointer;
}

.user-container {
  display: flex;
  align-items: center;
}

.menu-list {
  padding: 1rem;
}

.menu-item {
  padding-left: 1rem;
}

.v-icon {
  margin-right: 1rem;
}

.btn-alerta {
  border-color: red !important;
  color: red !important;
  font-size: 22px;
  font-weight: 800;
  text-transform: none;
  padding: 4px 12px !important;
  max-width: 800px;
  animation: pulse 2s infinite;
  background-color: rgba(255, 0, 0, 0.1) !important;
  transition: all 0.3s ease;
}

.btn-alerta:hover {
  background-color: rgba(255, 0, 0, 0.2) !important;
  transform: scale(1.05);
}

.user-info {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.user-info span {
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.375rem;
  text-align: justify;
  color: var(--text-primary, #4E4E4E);
}

.user-info h5 {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--text-muted, #A4A8AB);
}

.v-list-item span {
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: var(--text-primary, #4E4E4E);
}

.v-list-item .v-icon {
  color: var(--text-primary, #4E4E4E);
}

.v-menu__content {
  margin-top: 1rem;
}

.info-paciente {
  margin-top: 1rem;
  margin-right: 1rem;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: justify;
  gap: 0.5rem;
  color: var(--text-primary, #4E4E4E);
}

.info-paciente span {
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: justify;
}

.btn-paciente {
  background-color: var(--especialidade-primary, #2e4b9d);
  border-radius: 4px;
  padding: 0.5rem 1rem 0.5rem 1rem !important;
  gap: 0.5rem;
  color: #fff;
  margin-top: 1rem;
}

.btn-paciente .v-btn__content {
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1rem;
  letter-spacing: 0.32px;
  text-align: justify;
  text-transform: capitalize;
}

.icon-btn {
  margin-right: 0.5rem !important;
}

.separador-vertical {
  color: var(--especialidade-primary, #2e4b9d);
  font-size: 2rem;
  margin: 0 1.5rem;
  font-weight: 300;
}

.paciente-nome {
  font-size: 1.2rem;
  color: var(--text-primary, #4E4E4E);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}

.header-atendimento-actions {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
}

.v-app-bar {
  position: fixed;
  z-index: 1000;
  width: 100% !important;
  left: 0 !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  transition: margin-left 0.3s ease-in-out, width 0.3s ease-in-out;
}

.v-app-bar.sidebar-minimized {
  margin-left: 114px !important;
  width: calc(100% - 114px) !important;
}

.header-atendimento .v-toolbar__content {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding-bottom: 1rem;
}

.header-atendimento .v-toolbar__content::-webkit-scrollbar {
  height: 4px;
}

.header-atendimento .v-toolbar__content::-webkit-scrollbar-thumb {
  background-color: var(--especialidade-primary, #2e4b9d);
  border-radius: 10rem;
}

@media (max-width: 959px) {
  .v-app-bar {
    margin-left: 0 !important;
    width: 100% !important;
  }

  .v-app-bar.sidebar-minimized {
    margin-left: 0 !important;
    width: 100% !important;
  }
}

.v-application--is-ltr .v-app-bar:not(.sidebar-minimized) {
  padding-left: 0 !important;
  margin-left: 0 !important;
}

@keyframes pulse-info {
  0% {
    color: var(--especialidade-primary, #2e4b9d);
    text-shadow: 0 0 7px var(--especialidade-primary, #2e4b9d);
  }

  50% {
    color: var(--text-primary, #020202);
    text-shadow: 15 0 10px var(--especialidade-primary, #2e4b9d);
  }

  100% {
    color: var(--text-primary, #000000);
    text-shadow: 100 10 15px var(--especialidade-primary, #2e4b9d);
  }
}

.info-icon-pulse {
  animation: pulse-info 2s infinite ease-in-out;
  color: var(--especialidade-primary, #2e4b9d) !important;
}

@keyframes info-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(16, 168, 96, 0.2);
  }

  50% {
    box-shadow: 0 0 0 4px rgba(16, 168, 96, 0.1);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(16, 168, 96, 0.2);
  }
}

.info-btn-pulse {
  animation: info-pulse 1.5s infinite ease-in-out !important;
  border-radius: 50% !important;
  background-color: rgba(16, 168, 96, 0.1) !important;
}

.info-btn-pulse .v-icon {
  color: white !important;
}

.info-btn-pulse {
  background-color: var(--especialidade-primary, #2e4b9d) !important;
}

.especialidade-separador {
  color: var(--especialidade-primary, #2e4b9d) !important;
}

.info-btn-lampada {
  animation: info-pulse 2s infinite ease-in-out !important;
  border-radius: 50% !important;
  background-color: rgba(255, 229, 180, 0.4) !important;
}

.info-btn-lampada .v-icon {
  color: #FFB300 !important;
}

.cursor-pointer {
  cursor: pointer;
}

/* Dark mode overrides */
.theme--dark .user-info span {
  color: #e6e6e6;
}

.theme--dark .user-info h5 {
  color: #b0b0b0;
}

.theme--dark .v-list-item span {
  color: #e6e6e6;
}

.theme--dark .v-list-item .v-icon {
  color: #e6e6e6;
}

.theme--dark .info-paciente {
  color: #e6e6e6;
}

.theme--dark .paciente-nome {
  color: #e6e6e6;
}
</style>
